export const CLASS_MODALITIES = ["on_campus", "hybrid", "online"] as const;
export type ClassModality = (typeof CLASS_MODALITIES)[number];

export function normalizeTimeToHHmm(value?: string | null): string | undefined {
  if (!value) return undefined;
  const match = /^(\d{1,2}):(\d{2})/.exec(value);
  if (!match) return value;
  return `${match[1]?.padStart(2, "0")}:${match[2]}`;
}

export function formatClassForMobile(
  classItem: Record<string, unknown>,
): Record<string, unknown> {
  const location = classItem.location as
    | { latitude?: number; longitude?: number; name?: string }
    | undefined;
  const settings = classItem.settings as
    | { finalAttendanceTime?: string }
    | undefined;
  const semester = classItem.semesterId as
    | {
        _id?: unknown;
        semesterName?: string;
        academicYear?: string;
        startDate?: Date;
        endDate?: Date;
      }
    | undefined;
  const school = classItem.schoolId as
    | { _id?: unknown; schoolName?: string }
    | undefined;

  return {
    id: classItem._id ?? classItem.id,
    className: classItem.className,
    classCode: classItem.classCode ?? null,
    courseCode: classItem.courseCode ?? null,
    courseName: classItem.courseName ?? null,
    courseType: classItem.courseType ?? classItem.subject ?? null,
    modality: classItem.modality ?? "on_campus",
    department: classItem.department ?? classItem.subject ?? null,
    creditHours: classItem.credits ?? classItem.creditHours ?? null,
    description: classItem.description ?? null,
    status: classItem.status,
    isActive: classItem.isActive,
    maxStudents: classItem.maxStudents ?? null,
    currentStudents: Array.isArray(classItem.studentIds)
      ? classItem.studentIds.length
      : (classItem.currentStudents ?? 0),
    classRoom: classItem.classRoom ?? null,
    classRoomNumber: classItem.classRoomNumber ?? classItem.roomNumber ?? null,
    restRoomMinutes: classItem.restRoomMinutes ?? null,
    finalAttendanceTime:
      settings?.finalAttendanceTime ??
      classItem.finalAttendanceTime ??
      classItem.checkInEndTime ??
      null,
    schedule: Array.isArray(classItem.schedule)
      ? classItem.schedule.map((slot: Record<string, unknown>) => ({
          day: slot.day,
          startTime:
            normalizeTimeToHHmm(slot.startTime as string) ?? slot.startTime,
          endTime: normalizeTimeToHHmm(slot.endTime as string) ?? slot.endTime,
          isActive: slot.isActive ?? false,
        }))
      : [],
    location: {
      roomNumber: classItem.roomNumber ?? classItem.classRoomNumber ?? null,
      floor: classItem.floor ?? null,
      building: classItem.building ?? null,
      coordinates:
        location?.longitude != null && location?.latitude != null
          ? [location.longitude, location.latitude]
          : null,
    },
    school: school
      ? {
          id: school._id,
          name: school.schoolName,
        }
      : null,
    semester: semester
      ? {
          id: semester._id,
          semesterName: semester.semesterName,
          academicYear: semester.academicYear,
          startDate: semester.startDate,
          endDate: semester.endDate,
        }
      : null,
    createdAt: classItem.createdAt,
    updatedAt: classItem.updatedAt,
  };
}
